module.exports = __webpack_public_path__ + "media/images/fbcalls/bull_vs_bear_bg-566d124d975ba150a014e934fef9529e.png";